import React, { useState, useEffect, Fragment } from "react";
import { 
    TabContainer, 
    Tab, 
    Nav, 
    NavItem, 
    PageHeader, 
    Button, 
    Grid, 
    Row, 
    Col, 
    Glyphicon, 
    Label, 
    FormGroup, 
    Checkbox,
    ControlLabel,
    FormControl,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";
import { View } from "react-native";
// import LoaderButton from "../components/LoaderButton";
// import { Chart } from "react-charts";
import {CopyToClipboard} from 'react-copy-to-clipboard';
// import renderCapManager from './Admin/CapManager';
// import renderCapManager2 from './Admin/CapManager2';
import { 
    getUserData, 
    shareCapWithUser, 
    delSharing, 
    patchSharing,
    getAccessableCaps,
    getAllBuilders,
    getUsersByBuilder,
    getUserActions,
    getUserActionCount,
    getCapsByUserId,
    patchUser,
    getSharedCaps,
    getUsersBySharedOnCapsByBuilder,
    getCapsByBuilder,
    makeNewCap,
    patchBuilder,
    getCapHealthLog
} from "../utils/bedrockAPI";
import { 
    getUser,
} from "../utils/Common";
import "./Account.css";
import "./Admin.css";
import { LinkContainer } from "react-router-bootstrap";
import LoaderButton from "../components/LoaderButton";
import AddBuilderModal from "../components/AddBuilderModal";
import CapLogModal from "../components/CapLogModal";
import AllUsers from "./AllUsers";
import Transfers from "./Transfers";
import AdminCapMap from "./AdminCapMap";
import ContentEditable from "react-contenteditable";

// Module-level guard: Admin can mount/unmount repeatedly in quick succession; only one instance runs the initial fetch.
// We delay resetting the flag so a newly mounted instance sees "load already started" and skips.
// The instance that fetches may unmount before the async work completes; we resolve a shared promise so any mounted instance can receive the data.
let adminInitialLoadStarted = false;
let adminMountCount = 0;
let adminResetTimeoutId = null;
let adminInitialLoadPromise = null;
let adminInitialLoadPromiseResolve = null;
const ADMIN_LOAD_RESET_DELAY_MS = 200;

export default function Admin(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [caps, setCaps] = useState(null);
    const [builders, setBuilders] = useState(null);
    const [organizedCaps, setOrganizedCaps] = useState(null);
    const [focusedBuilder, setFocusedBuilder] = useState(null);
    const [activeTabKey, setActiveTabKey] = useState("caps");
    const [builderUsers, setBuilderUsers] = useState(null);
    const [builderUsersWithActions, setBuilderUsersWithActions] = useState(null);
    const [focusedUser, setFocusedUser] = useState(null);
    const [userChanges, setUserChanges] = useState({});
    const [builderCaps, setBuilderCaps] = useState(null);
    const [showAddBuilder, setShowAddBuilder] = useState(false);
    const [builderCapUsers, setBuilderCapUsers] = useState(null);
    const [newName, setNewName] = useState("New Cap");
    const [newPort, setNewPort] = useState("Port");
    const [statusSearchTerm, setStatusSearchTerm] = useState("");
    // const [searchTerm, setSearchTerm] = useState("");
    const [isMobile, setIsMobile] = useState(false);
    const [showHealthLog, setShowHealthLog] = useState(false);
    const [selectedCapForHealth, setSelectedCapForHealth] = useState(null);

    useEffect(() => {
        setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', () => {
            setIsMobile(window.innerWidth < 768);
        });
    }, []);

    function dateify(tempData) {
        for(var i=0; i<tempData.length; i++) {
            for(var j=0; j<tempData[i].data.length; j++) {
                tempData[i].data[j][0] = new Date(tempData[i].data[j][0]);
            }
        }
        // console.log(tempData);
        return tempData;
    }

    useEffect(() => {
        let isMounted = true;
        if(isMounted)
            props.setShowError(false);
        return () => { isMounted = false; };
    },[]);

    // async function accessUserGrid() {
    //     let tempGrid = await getSharingGrid();
    //     setUserGrid(tempGrid);
    // }

    useEffect(() => {
        adminMountCount++;
        if (adminInitialLoadStarted) {
            if (adminResetTimeoutId) clearTimeout(adminResetTimeoutId);
            adminResetTimeoutId = null;
            let cancelled = false;
            if (adminInitialLoadPromise) {
                adminInitialLoadPromise.then((result) => {
                    if (!cancelled && result) {
                        setCaps(result.caps);
                        setData(result.data);
                        setBuilders(result.builders);
                    }
                }).catch(() => {});
            }
            return () => {
                cancelled = true;
                adminMountCount--;
                if (adminMountCount === 0) {
                    adminResetTimeoutId = setTimeout(() => {
                        adminResetTimeoutId = null;
                        if (adminMountCount === 0) {
                        adminInitialLoadStarted = false;
                        adminInitialLoadPromise = null;
                        adminInitialLoadPromiseResolve = null;
                    }
                    }, ADMIN_LOAD_RESET_DELAY_MS);
                }
            };
        }
        if (adminResetTimeoutId) clearTimeout(adminResetTimeoutId);
        adminResetTimeoutId = null;
        adminInitialLoadStarted = true;
        adminInitialLoadPromise = new Promise((resolve) => { adminInitialLoadPromiseResolve = resolve; });

        let isMounted = true;

        async function accessCaps() {
            if(getUser() && getUser().role==='ADMIN') {
                // console.log('[Admin API] getAccessableCaps(true)');
                var tempCaps = await getAccessableCaps(true);
                tempCaps.sort((a,b) => (a.name < b.name) ? 1 : -1);
                if(isMounted) setCaps(tempCaps);
                return tempCaps;
            }
            return null;
        }

        async function accessUserData() {
            if(getUser() && getUser().role==='ADMIN') {
                // console.log('[Admin API] getUserData(false)');
                var tempData = await getUserData(false);  // Without ADMINs
                tempData = dateify(tempData);
                if(isMounted) setData(tempData);
                return tempData;
            }
            return null;
        }

        async function accessBuilders() {
            if(getUser() && getUser().role==='ADMIN') {
                // console.log('[Admin API] getAllBuilders()');
                var tempBuilders = await getAllBuilders();
                if(isMounted) setBuilders(tempBuilders);
                return tempBuilders;
            }
            return null;
        }

        setIsLoading(true);
        Promise.all([accessUserData(), accessCaps(), accessBuilders()]).then(([tempData, tempCaps, tempBuilders]) => {
            if (adminInitialLoadPromiseResolve) {
                adminInitialLoadPromiseResolve({ caps: tempCaps, data: tempData, builders: tempBuilders });
                adminInitialLoadPromiseResolve = null;
            }
        }).catch((err) => {
            if (adminInitialLoadPromiseResolve) {
                adminInitialLoadPromiseResolve(null);
                adminInitialLoadPromiseResolve = null;
            }
        });
        setIsLoading(false);
        return () => {
            adminMountCount--;
            if (adminMountCount === 0) {
                adminResetTimeoutId = setTimeout(() => {
                    adminResetTimeoutId = null;
                    if (adminMountCount === 0) {
                        adminInitialLoadStarted = false;
                        adminInitialLoadPromise = null;
                        adminInitialLoadPromiseResolve = null;
                    }
                }, ADMIN_LOAD_RESET_DELAY_MS);
            }
            isMounted = false;
        };
    }, []);

    async function createNew(architecture='') {
        setIsLoading(true);
        // console.log('[Admin API] makeNewCap', newName, newPort, architecture);
        makeNewCap(newName,newPort,architecture);
        // console.log(newCap);
        // TODO: show success of new cap
        props.setShowError(true);
        props.setErrorMessage(`New ${architecture.length > 0 ? architecture : "Legacy"} Camera successfully created`);
        props.setErrorStatus("success-message");
        setIsLoading(false);
    }
    var handleNameChange = function(event) {
        setNewName(event.target.value.replace(/(<([^>]+)>)/ig,""));
    };
  
    var handlePortChange = function(event) {
        setNewPort(event.target.value)
    };
  
    var pastAsPlainText = function(event) {
        event.preventDefault();

        const text = event.clipboardData.getData('text/plain');
        document.execCommand('insertHTML',false,text);
    };
  
    var disableNewLines = function(event) {
        const keyCode = event.keyCode || event.which;

        if(keyCode === 13) {
            event.returnValue = false;
            if (event.preventDefault) event.preventDefault()
        }
    };
  
    var highlightAll = function(event) {
        setTimeout(() => {
            document.execCommand('selectAll', false, null);
        }, 0);
    }

    function openHealthLog(cap) {
        setSelectedCapForHealth(cap);
        setShowHealthLog(true);
    }


    // useEffect(() => {
    //     let isMounted = true;
    //     if(isMounted) accessUserData();
    //     return () => { isMounted = false; };
    // },[showAdmin])

    useEffect(() => {
        let isMounted = true;
        if(builders && caps && builders.length>0 && caps.length>0) {
            let tempOrganizedCaps = [];
            let buildCaps = [];
            
            // First collect all caps that aren't assigned to a builder
            for(i=0; i<caps.length; i++) {
                let contains = false;
                // Find caps that aren't already added
                for(var j=0; j<tempOrganizedCaps.length; j++) {
                    let oc = tempOrganizedCaps[j];
                    if(oc.capId && oc.capId===caps[i].capId) {
                        contains = true;
                        break;
                    }
                }
                if(!contains && !caps[i].builderId) {
                    buildCaps.push(caps[i]);
                }
            }

            // Add NOT YET ACTIVATED section first
            tempOrganizedCaps.push({"builder_id":null,"name":"NOT YET ACTIVATED"});
            for(i=0; i<buildCaps.length; i++) {
                tempOrganizedCaps.push(buildCaps[i]);
            }

            // Then add all builders and their caps
            for(var i=0; i<builders.length; i++) {
                // Add Builder Headers
                if(builders[i].status!=='DEAD') {
                    tempOrganizedCaps.push(builders[i]);
                    // Match caps to builders
                    for(var j=0; j<caps.length; j++) {
                        if(caps[j].builderId && caps[j].builderId===builders[i].builderId) {
                            tempOrganizedCaps.push(caps[j]);
                        }
                    }
                }
            }

            // Add Unassigned section
            tempOrganizedCaps.push({"builder_id":null,"name":"Unassigned"});
            for(i=0; i<caps.length; i++) {
                let contains = false;
                // Find caps that aren't already added
                for(var j=0; j<tempOrganizedCaps.length; j++) {
                    let oc = tempOrganizedCaps[j];
                    if(oc.capId && oc.capId===caps[i].capId) {
                        contains = true;
                        break;
                    }
                }
                if(!contains) {
                    tempOrganizedCaps.push(caps[i]);
                }
            }

            if(isMounted) {
                setOrganizedCaps(tempOrganizedCaps);
            }
        }
        return () => { isMounted = false; };
    },[builders,caps]);

    useEffect(() => {
        let isMounted = true;
        async function accessBuilderUsers() {
            // console.log('[Admin API] getUsersByBuilder', focusedBuilder.builderId);
            var tempBuilderUsers = await getUsersByBuilder(focusedBuilder.builderId);
            if(isMounted) {
                setBuilderUsers(tempBuilderUsers);
            }
        }
        if(focusedBuilder && focusedBuilder.builderId) {
            accessBuilderUsers();
        }
        return () => { isMounted = false; };
    },[focusedBuilder]);

    useEffect(() => {
        let isMounted = true;
        async function accessUserInformation() {
            var tempBuilderUsers = JSON.parse(JSON.stringify(builderUsers));
            await Promise.all(tempBuilderUsers.map(async (user,i) => {
                // console.log('[Admin API] getUserActions', user.userId);
                const userActions = await getUserActions(user.userId);
                // console.log('[Admin API] getUserActionCount', user.userId);
                const userActionCount = await getUserActionCount(user.userId);
                // console.log('[Admin API] getCapsByUserId', user.userId);
                const userCaps = await getCapsByUserId(user.userId);
                tempBuilderUsers[i].userActions = userActions;
                tempBuilderUsers[i].userActionCount = userActionCount;
                tempBuilderUsers[i].caps = userCaps;
            }));
            if(isMounted) {
                setBuilderUsersWithActions(tempBuilderUsers);
            }
            let tempBuilderCaps = {}
            for(var i=0;i<tempBuilderUsers.length;i++) {
                for(var j=0;j<tempBuilderUsers[i].caps.length;j++) {
                    if(tempBuilderCaps[tempBuilderUsers[i].caps[j].capId]==null) {
                        tempBuilderCaps[tempBuilderUsers[i].caps[j].capId] = tempBuilderUsers[i].caps[j];
                    }
                }
            }
            if(isMounted) {
                setBuilderCaps(Object.values(tempBuilderCaps));
            }
        }
        if(builderUsers && builderUsers.length > 0) {
            accessUserInformation();
        } else {
            async function accessCapBuilders() {
                // console.log('[Admin API] getCapsByBuilder', focusedBuilder.builderId);
                var tempCaps = await getCapsByBuilder(focusedBuilder.builderId);
                if(isMounted)
                    setBuilderCaps(tempCaps);
            }
            if(focusedBuilder) {
                accessCapBuilders();
                if(isMounted)
                    setBuilderUsersWithActions([]);
            }
        }
        return () => { isMounted = false; };
    },[builderUsers]);

    useEffect(() => {
        let isMounted = true;
        async function accessBuilderCapUsers() {
            // console.log('[Admin API] getUsersBySharedOnCapsByBuilder', focusedBuilder.builderId);
            let tempBuilderCapUsers = await getUsersBySharedOnCapsByBuilder(focusedBuilder.builderId);
            for(var i=0; i<tempBuilderCapUsers.length; i++) {
                if(isMounted) {
                    // console.log('[Admin API] getSharedCaps (builderCapUsers)', tempBuilderCapUsers[i].userId);
                    const userCaps = await getSharedCaps(tempBuilderCapUsers[i].userId);
                    tempBuilderCapUsers[i].userCaps = userCaps;
                }
            }
            let reduced = [];
            if(builderUsersWithActions) {
                for(var i=0;i <tempBuilderCapUsers.length; i++) {
                    let contains = false;
                    for(var j=0; j<builderUsersWithActions.length; j++) {
                        if(tempBuilderCapUsers[i].userId === builderUsersWithActions[j].userId) {
                            contains = true;
                            break;
                        }
                    }
                    if(!contains) {
                        reduced.push(tempBuilderCapUsers[i]);
                    }
                }
            } else {
                reduced = tempBuilderCapUsers;
            }
            if(isMounted)
                setBuilderCapUsers(reduced);
        }
        if(focusedBuilder)
            accessBuilderCapUsers();
        return () => { isMounted = false; };
    },[builderUsersWithActions,focusedBuilder]);

    useEffect(() => {
        let isMounted = true;
        async function updateFocusedUser() {
            var tempFocusedUser = JSON.parse(JSON.stringify(focusedUser));
            // console.log('[Admin API] getSharedCaps (focusedUser)', focusedUser.userId);
            const tempUserCaps = await getSharedCaps(focusedUser.userId);
            tempFocusedUser.userCaps = tempUserCaps;
            if(isMounted)
                setFocusedUser(tempFocusedUser);
        }
        if(focusedUser && !focusedUser.userCaps) {
            updateFocusedUser();
        }
        return () => { isMounted = false; };
    },[focusedUser])

    // const axes = useMemo(() => [
    //     { primary: true, type: 'utc', position: 'bottom' },
    //     { type: 'linear', position: 'left' }
    // ], [])

    // const hourAxes = useMemo(() => [
    //     { primary: true, type: 'linear', position: 'bottom' },
    //     { type: 'linear', position: 'left' }
    // ], [])

    // const capAxes = useMemo(() => [
    //     { primary: true, type: 'ordinal', position: 'bottom' },
    //     { type: 'linear', position: 'left' }
    // ], [])

    // const series = useMemo(() => ({
    //     type: 'line'
    // }),[]);

    // const hourSeries = useMemo(() => ({
    //     type: 'bar'
    // }),[]);

    function renderStatsMenus() {
        return (
            <div className="admin-shell">
                <TabContainer 
                    id="admin-tabs" 
                    defaultActiveKey="caps"
                    activeKey={activeTabKey}
                    onSelect={(key) => setActiveTabKey(key)}
                    className="admin-tabs"
                >
                    <Row className="clearfix admin-layout-row">
                        <Col sm={12} md={3} lg={2} className="admin-nav-col">
                            <Nav bsStyle="pills" stacked className="admin-nav">
                                <NavItem eventKey="users">
                                    <Glyphicon glyph="user" style={{marginRight: "8px"}} />Login Data
                                </NavItem>
                                {/* <NavItem eventKey="userHours">
                                    User Stats By Hour
                                </NavItem> */}
                                {/* <NavItem eventKey="userCaps">
                                    Cap Stats By User
                                </NavItem> */}
                                {/* <NavItem eventKey="sharingManager" onClick={() => accessUserGrid()}>
                                    Sharing Manager
                                </NavItem> */}
                                <NavItem eventKey="caps">
                                    <Glyphicon glyph="camera" style={{marginRight: "8px"}} />Statuses
                                </NavItem>
                                {/* <NavItem eventKey="capManager">
                                    Cap Manager
                                </NavItem> */}
                                {/* <NavItem eventKey="builder">
                                    Builder Info
                                </NavItem>
                                <NavItem eventKey="userInfo">
                                    User Info
                                </NavItem> */}
                                <NavItem eventKey="allUsers">
                                    <Glyphicon glyph="list" style={{marginRight: "8px"}} />All Users
                                </NavItem>
                                <LinkContainer to="/admin/orders">
                                    <NavItem eventKey="orders">
                                        <Glyphicon glyph="shopping-cart" /> Orders
                                    </NavItem>
                                </LinkContainer>
                                <NavItem eventKey="transfers">
                                    <Glyphicon glyph="transfer" style={{marginRight: "8px"}} />Transfers
                                </NavItem>
                                <LinkContainer to="/admin/cap-software">
                                    <NavItem eventKey="capSoftware">
                                        <Glyphicon glyph="refresh" /> Cap software
                                    </NavItem>
                                </LinkContainer>
                                <NavItem eventKey="map">
                                    <Glyphicon glyph="map-marker" style={{marginRight: "8px"}} />Map
                                </NavItem>
                            </Nav>
                        </Col>
                        <Col sm={12} md={9} lg={10} className="admin-content-col">
                            <Tab.Content className="admin-tab-content">
                                <Tab.Pane eventKey="users">{!isLoading && renderUsers()}</Tab.Pane>
                                {/* <Tab.Pane eventKey="userHours">{!isLoading && renderUserHours()}</Tab.Pane> */}
                                {/* <Tab.Pane eventKey="userCaps">{!isLoading && renderUserCaps()}</Tab.Pane> */}
                                {/* <Tab.Pane eventKey="sharingManager">{!isLoading && caps && renderSharingManager()}</Tab.Pane> */}
                                <Tab.Pane eventKey="caps">{!isLoading && renderCapStatuses()}</Tab.Pane>
                                {/* <Tab.Pane eventKey="capManager">{!isLoading && renderCapManager2(caps,isLoading)}</Tab.Pane> */}
                                <Tab.Pane eventKey="builder">{!isLoading && renderBuilderInfo()}</Tab.Pane>
                                <Tab.Pane eventKey="userInfo">{!isLoading && renderUserInfo()}</Tab.Pane>
                                <Tab.Pane eventKey="allUsers">{!isLoading && activeTabKey === "allUsers" && renderAllUsers()}</Tab.Pane>
                                <Tab.Pane eventKey="transfers">{!isLoading && activeTabKey === "transfers" && renderTransfers()}</Tab.Pane>
                                <Tab.Pane eventKey="map">{!isLoading && activeTabKey === "map" && renderCapMap()}</Tab.Pane>
                                {/* <Tab.Pane eventKey="orders">{!isLoading && renderOrders()}</Tab.Pane> */}
                            </Tab.Content>
                        </Col>
                    </Row>
                </TabContainer>
            </div>
        )
    }

    function renderUserInfo() {
        function changeUser(key,value) {
            var tempUser = JSON.parse(JSON.stringify(focusedUser));
            tempUser[key] = value;
            setFocusedUser(tempUser);
            var tempUserChanges = JSON.parse(JSON.stringify(userChanges));
            // if(value==="") value = null;
            tempUserChanges[key] = value; 
            setUserChanges(tempUserChanges);
        }
        async function updateUser(e) {
            e.preventDefault();
            // setIsLoading(true);
            // console.log(userChanges,focusedUser.userId)
            // console.log('[Admin API] patchUser', focusedUser.userId, userChanges);
            await patchUser(focusedUser.userId,userChanges);
            setUserChanges({});
            var tempBuilderUsersWithActions = JSON.parse(JSON.stringify(builderUsersWithActions));
            for(var i=0; i<tempBuilderUsersWithActions.length; i++) {
                if(tempBuilderUsersWithActions[i].userId===focusedUser.userId) {
                    tempBuilderUsersWithActions[i] = focusedUser;
                    break;
                }
            }
            setBuilderUsersWithActions(tempBuilderUsersWithActions);
            // setIsLoading(false);
        }
        function lookupAccess(capId) {
            if(focusedUser && focusedUser.userCaps) {
                for(var i=0;i<focusedUser.userCaps.length; i++) {
                    if(focusedUser.userCaps[i] && focusedUser.userCaps[i].capId===capId) {
                        return focusedUser.userCaps[i];
                    }
                }
            }
            return null;
        }

        function getBsStyle(userCap) {
            if(focusedUser && focusedUser.role==="ADMIN") {
                return "success";
            } else {
                if(userCap && userCap.accessType) {
                    if(userCap.accessType === "OWNER") {
                        return "success";
                    } else if(userCap.accessType === "VIEWER") {
                        return "info";
                    } else if(userCap.accessType === "DEMO") {
                        return "warning";
                    } else if(userCap.accessType === "SALES_DEMO") {
                        return "info";
                    }
                } else {
                    return "danger";
                }
            }
        }
    
        function findUserCapIndex(uc) {
            for(var i=0; i<focusedUser.userCaps.length;i++) {
                if(focusedUser.userCaps[i].userCapId===uc.userCapId) {
                    return i;
                }
            }
        }
    
        async function handleUpdateAccess(cap) {
            // console.log(userId,cap)
            const userCap = lookupAccess(cap);
            if(userCap) {
                if(userCap.accessType==="DEMO") {
                    // set to VIEWER
                    var tempUser = JSON.parse(JSON.stringify(focusedUser));
                    const newShare = {userCapId:userCap.userCapId,accessType:"VIEWER"};
                    // console.log('[Admin API] patchSharing (VIEWER)', userCap.userCapId);
                    await patchSharing(userCap.userCapId,newShare);
                    tempUser.userCaps[findUserCapIndex(userCap)].accessType = "VIEWER";
                    setFocusedUser(tempUser);
                } else if(userCap.accessType==="VIEWER") {
                    // set to OWNER
                    tempUser = JSON.parse(JSON.stringify(focusedUser));
                    const newShare = {userCapId:userCap.userCapId,accessType:"OWNER"};
                    // console.log('[Admin API] patchSharing (OWNER)', userCap.userCapId);
                    await patchSharing(userCap.userCapId,newShare);
                    tempUser.userCaps[findUserCapIndex(userCap)].accessType = "OWNER";
                    setFocusedUser(tempUser);
                } else if(userCap.accessType==="OWNER") {
                    // set to null
                    tempUser = JSON.parse(JSON.stringify(focusedUser));
                    // console.log('[Admin API] delSharing', userCap.userCapId);
                    await delSharing(userCap.userCapId);
                    delete tempUser.userCaps[findUserCapIndex(userCap)];
                    setFocusedUser(tempUser);
                }
            } else {    
                // Set to DEMO
                tempUser = JSON.parse(JSON.stringify(focusedUser));
                // console.log('[Admin API] shareCapWithUser', cap.capId || cap, focusedUser.userId, 'DEMO');
                const newUserCap = (await shareCapWithUser(cap,focusedUser.userId,"DEMO")).data;
                tempUser.userCaps.push(newUserCap);
                setFocusedUser(tempUser);
            }
        }
    
        async function handleUpdatePowerNotifications(cap) {
            let userCap = lookupAccess(cap);
            if(userCap) {
                const currentPN = userCap.powerNotifications;
                var tempUser = JSON.parse(JSON.stringify(focusedUser));
                const newShare = {userCapId:userCap.userCapId,powerNotifications:!currentPN}
                // console.log('[Admin API] patchSharing (powerNotifications)', userCap.userCapId);
                await patchSharing(userCap.userCapId,newShare);
                tempUser.userCaps[findUserCapIndex(userCap)].powerNotifications = !currentPN;
                setFocusedUser(tempUser);
            }
        }

        return (
            <View>
                <Grid>
                    <Row key={-1}>
                        <Col md={10}>
                            <div className="builder">
                                <PageHeader>
                                    <View style={{flex:1,flexDirection:"row",justifyContent:"space-between"}}>
                                        <View style={{paddingRight:"10px"}}>
                                            <OverlayTrigger placement="left" overlay={(
                                                <Tooltip id="copier" style={{fontSize:"18px"}}>
                                                    Copy email
                                                </Tooltip>
                                            )}>
                                                <CopyToClipboard
                                                    text={focusedUser ? focusedUser.email : ""}
                                                >
                                                    <Button 
                                                        bsSize="large"
                                                        bsStyle="default"
                                                    ><Glyphicon glyph="duplicate" /></Button>
                                                </CopyToClipboard>
                                            </OverlayTrigger>
                                        </View>
                                        <div>
                                            {focusedUser && focusedUser.email}
                                        </div>
                                        <View style={{flex:1,flexDirection:"row",justifyContent:"flex-end"}}>
                                            <View style={{paddingRight:"5px"}}>
                                                <OverlayTrigger placement="left" overlay={(
                                                    <Tooltip id="copier" style={{fontSize:"18px"}}>
                                                        Copy user_id
                                                    </Tooltip>
                                                )}>
                                                    <CopyToClipboard
                                                        text={focusedUser ? focusedUser.userId : ""}
                                                    >
                                                        <Button 
                                                            bsSize="large"
                                                            bsStyle="default"
                                                        ><Glyphicon glyph="duplicate" /></Button>
                                                    </CopyToClipboard>
                                                </OverlayTrigger>
                                            </View>
                                            <Button
                                                bsStyle="info"
                                                bsSize="large"
                                                onClick={() => {
                                                    setActiveTabKey("builder");
                                                }}
                                            >
                                                Builder
                                            </Button>
                                        </View>
                                    </View>
                                </PageHeader>
                            </div>
                        </Col>
                    </Row>
                    {focusedUser && (
                        <form className="info" onSubmit={(e) => updateUser(e)}>
                            <Row key={0} style={{paddingBottom:"5px"}}>
                                <Col md={5}>
                                    <FormGroup>
                                        <ControlLabel>First Name</ControlLabel>
                                        <FormControl
                                            autoFocus
                                            value={focusedUser.firstName}
                                            // disabled={true}
                                            onChange={(e) => changeUser("firstName",e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={5}>
                                    <FormGroup>
                                        <ControlLabel>Last Name</ControlLabel>
                                        <FormControl
                                            value={focusedUser.lastName}
                                            // disabled={true}
                                            onChange={(e) => changeUser("lastName",e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row key={1} style={{paddingBottom:"10px"}}>
                                <Col md={10}>
                                    <View style={{flex:1, flexDirection:"row",justifyContent:"flex-end"}}>
                                        <LoaderButton
                                            type="submit"
                                            bsSize="large"
                                            disabled={Object.keys(userChanges).length===0}
                                            isLoading={isLoading}
                                        >
                                            Save Name Changes
                                        </LoaderButton>
                                    </View>
                                </Col>
                            </Row>
                        </form>
                    )}
                    {builderCaps && builderCaps.map((cap,i) => (
                        <Row key={i+2}>
                            <Col md={5}>
                                {cap.neighborhood ? cap.neighborhood+', '+cap.name : cap.name}
                            </Col>
                            <Col md={5}>
                                <form>
                                    <FormGroup controlId={cap.capId}>
                                        <Button 
                                            bsStyle={getBsStyle(lookupAccess(cap.capId))} 
                                            style={{width:"100%"}}
                                            disabled={focusedUser && focusedUser.role==="ADMIN"}
                                            onClick={() => handleUpdateAccess(cap.capId)}
                                        >
                                            {focusedUser && focusedUser.role==="ADMIN" ? "ADMIN" : lookupAccess(cap.capId) ? lookupAccess(cap.capId).accessType : "DENIED"}
                                        </Button> 
                                        {lookupAccess(cap.capId) && (
                                            <Checkbox checked={lookupAccess(cap.capId).powerNotifications} onChange={() => handleUpdatePowerNotifications(cap.capId)}>
                                                <Glyphicon glyph="envelope" />
                                            </Checkbox>
                                        )}
                                    </FormGroup>
                                </form>
                            </Col>
                        </Row>
                    ))}
                </Grid>
            </View>
        )
    }

    function renderBuilderInfo() {
        function convertDate(actionDate) {
            const date = new Date(actionDate);
            const today = new Date();
            let yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate()-1)
            if(date.getDate()===today.getDate()) {
                return "Today"
            } else if (date.getDate()===yesterday.getDate()) {
                return "Yesterday"
            } else {
                return date.getMonth()+1+"/"+date.getDate()+"/"+date.getFullYear();
            }
        }
        function calculateCapAccess(userId,capId) {
            for(var i=0; i<builderCapUsers.length; i++) {
                if(builderCapUsers[i].userId===userId) {
                    for(var j=0; j<builderCapUsers[i].userCaps.length; j++) {
                        if(builderCapUsers[i].userCaps[j].capId===capId) {
                            return builderCapUsers[i].userCaps[j].accessType;
                        }
                    }
                }
            }
            return "DENIED";
        }
        let builderLength = builderUsersWithActions ? builderUsersWithActions.length : 0;
        return (
            <View>
                <Grid>
                    <Row key={-2}>
                        <Col md={10}>
                            <div className="builder">
                                <PageHeader>
                                    <View style={{flex:1,flexDirection:"row",justifyContent:"space-between"}}>
                                        <div>
                                            {focusedBuilder && focusedBuilder.name}
                                        </div>
                                        <View style={{flex:1,flexDirection:"row",justifyContent:"flex-end"}}>
                                            <View style={{paddingRight:"5px"}}>
                                                <OverlayTrigger placement="left" overlay={(
                                                    <Tooltip id="copier" style={{fontSize:"18px"}}>
                                                        Copy builder_id
                                                    </Tooltip>
                                                )}>
                                                    <CopyToClipboard
                                                        text={focusedBuilder ? focusedBuilder.builderId : ""}
                                                    >
                                                        <Button 
                                                            bsSize="large"
                                                            bsStyle="default"
                                                        >
                                                            <Glyphicon glyph="duplicate" />
                                                        </Button>
                                                    </CopyToClipboard>
                                                </OverlayTrigger>
                                            </View>
                                            <Button
                                                bsStyle="info"
                                                bsSize="large"
                                                onClick={() => {
                                                    setActiveTabKey("caps");
                                                }}
                                            >
                                                Statuses
                                            </Button>
                                        </View>
                                    </View>
                                </PageHeader>
                            </div>
                        </Col>
                    </Row>
                    <Row key={-1} style={{fontWeight:"bold",paddingBottom:"15px"}}>
                        <Col md={1}>
                            First
                        </Col>
                        <Col md={1}>
                            Last
                        </Col>
                        <Col md={3}>
                            Email
                        </Col>
                        <Col md={1}>
                            Access
                        </Col>
                        <Col md={2}>
                            Clicks (week)
                        </Col>
                        <Col md={1}>
                            CAPs
                        </Col>
                    </Row>
                    {builderUsersWithActions==null ? (
                        <Row key={0}>
                            <Col md={10}>
                                Loading...
                            </Col>
                        </Row>
                        ) : builderUsersWithActions.length===0 ? (
                            <Row key={0}>
                                <Col md={10}>
                                    No Users Assigend to Builder
                                </Col>
                            </Row>
                        ) : builderUsersWithActions && builderUsersWithActions.map((user,i) => (
                        <Row key={i+663453} style={user.role==="CUSTOMER" ? {} : {color:"red"}}>
                            <Col md={1} onClick={() => {
                                setActiveTabKey("userInfo")
                                setFocusedUser(user);
                            }}>
                                {user.firstName}
                            </Col>
                            <Col md={1} onClick={() => {
                                setActiveTabKey("userInfo")
                                setFocusedUser(user);
                            }}>
                                {user.lastName}
                            </Col>
                            <Col md={3} style={{fontSize:"12px"}} onClick={() => {
                                setActiveTabKey("userInfo")
                                setFocusedUser(user);
                            }}>
                                <View style={{flex:1, flexDirection:"row",justifyContent:"space-between"}}>
                                    <div>
                                        {user.email}
                                    </div>
                                    <OverlayTrigger placement="left" overlay={(
                                        <Tooltip id="copier" style={{fontSize:"10px"}}>
                                            copy email
                                        </Tooltip>
                                    )}>
                                        <CopyToClipboard
                                            text={user.email}
                                        >
                                            <Button 
                                                bsSize="small"
                                                bsStyle="default"
                                            ><Glyphicon glyph="duplicate" /></Button>
                                        </CopyToClipboard>
                                    </OverlayTrigger>
                                </View>
                            </Col>
                            <Col md={1}>
                                {user.userActions && user.userActions[0] && convertDate(user.userActions[0].actionDate)}
                            </Col>
                            <Col md={2}>
                                { user.userActionCount && user.userActionCount.count}
                            </Col>
                            <Col md={1}>
                                { user.caps && user.caps.length }
                            </Col>
                            <Col md={1}>
                                <OverlayTrigger placement="left" overlay={(
                                    <Tooltip id="removeUserBuilder" style={{fontSize:"12px"}}>
                                        Remove User from Builder
                                    </Tooltip>
                                )}>
                                    <Button
                                        bsStyle="danger"
                                        bsSize="small"
                                        onClick = {() => {
                                            // console.log('[Admin API] patchUser (remove from builder)', user.userId);
                                            patchUser(user.userId,{builderId:null});
                                            let thisBuilder = JSON.parse(JSON.stringify(focusedBuilder));
                                            setFocusedBuilder(null);
                                            setFocusedBuilder(thisBuilder);
                                        }}
                                    >
                                        <Glyphicon glyph="minus" />
                                    </Button>
                                </OverlayTrigger>
                            </Col>
                        </Row>
                    ))}
                    {builderCapUsers && builderCaps && builderCapUsers.length>0 && (
                        <Fragment>
                            <Row key={builderLength+1} style={{paddingTop:"15px",paddingBottom:"5px"}}>
                                <Col md={6}>
                                    <u>Other Users</u>
                                </Col>
                            </Row>
                            <Row key={builderLength+2} style={{paddingBottom:"5px"}}>
                                <Col md={3}>

                                </Col>
                                {builderCaps && builderCaps.map((cap,j) => (
                                    <Col key={j+234234} md={1} style={{fontSize:"12px"}}>
                                        <b>{cap.name}</b>
                                    </Col>
                                ))}
                            </Row>
                        </Fragment>
                    )}
                    {builderCapUsers && builderCaps && builderCapUsers.map((user,i) => (
                        <Row key={i+9392029393} style={{overflowX:scroll}}>
                            <Col md={2} onClick={() => {
                                setActiveTabKey("userInfo")
                                setFocusedUser(user);
                            }}>
                                <div style={{fontSize:"12px",color:user.role==="CUSTOMER"?"black":"red"}}>
                                    {user.email}
                                </div>
                            </Col>
                            <Col md={1}>
                                <OverlayTrigger placement="left" overlay={(
                                    <Tooltip id="addUserToBuilder" style={{fontSize:"12px"}}>
                                        Add User To Builder
                                    </Tooltip>
                                )}>
                                    <Button
                                        bsStyle="success"
                                        bsSize="small"
                                        onClick = {() => {
                                            // console.log('[Admin API] patchUser (add to builder)', user.userId, focusedBuilder.builderId);
                                            patchUser(user.userId,{builderId:focusedBuilder.builderId});
                                            let thisBuilder = JSON.parse(JSON.stringify(focusedBuilder));
                                            setFocusedBuilder(null);
                                            setFocusedBuilder(thisBuilder);
                                        }}
                                    >
                                        <Glyphicon glyph="plus" />
                                    </Button>
                                </OverlayTrigger>
                            </Col>
                            {builderCaps && builderCaps.map((cap,j) => (
                                <Col key={j+4330423} md={1}>
                                    {calculateCapAccess(user.userId,cap.capId)}
                                </Col>
                            ))}
                        </Row>
                    ))}
                </Grid>
            </View>
        )
    }

    function renderCapStatuses() {
        async function refreshStatuses() {
            setIsLoading(true);
            try {
                const [tempCaps, tempBuilders] = await Promise.all([
                    getAccessableCaps(true),
                    getAllBuilders()
                ]);
                tempCaps.sort((a,b) => (a.name < b.name) ? 1 : -1);
                setCaps(tempCaps);
                setBuilders(tempBuilders);
            } finally {
                setIsLoading(false);
            }
        }
        
        function stylePicker(health, status) {
            if(status === 'DECOMISSIONED') {
                return "default";
            } else if(health==="POWER_LOSS") {
                return "danger";
            } else if(health==="ERROR") {
                return "danger";
            } else if(health==="DOWN") {
                return "default";
            } else if(health==="BATTERY") {
                return "warning";
            } else if(health==="ONLINE") {
                return "success";
            } else {
                return "default";
            }
        }

        const filteredCaps = organizedCaps ? organizedCaps.filter(cap => {
            // Skip builder entries (those without capId) when searching
            if (statusSearchTerm && !cap.capId) return false;
            
            // Always exclude DECOMMISSIONED caps in default state
            if (!statusSearchTerm && cap.status === 'DECOMISSIONED') {
                return false;
            }
            
            if (!statusSearchTerm) return true;
            
            const searchLower = statusSearchTerm.toLowerCase();
            
            // For DECOMMISSIONED caps, only show if search matches cap properties directly
            if (cap.status === 'DECOMISSIONED') {
                // Search in cap name
                if (cap.name && cap.name.toLowerCase().includes(searchLower)) return true;
                
                // Search in neighborhood
                if (cap.neighborhood && cap.neighborhood.toLowerCase().includes(searchLower)) return true;
                
                // Search in cap ID
                if (cap.capId && cap.capId.toLowerCase().includes(searchLower)) return true;
                
                return false;
            }
            
            // For non-DECOMMISSIONED caps, search in all properties
            // Search in cap name
            if (cap.name && cap.name.toLowerCase().includes(searchLower)) return true;
            
            // Search in neighborhood
            if (cap.neighborhood && cap.neighborhood.toLowerCase().includes(searchLower)) return true;
            
            // Search in cap ID
            if (cap.capId && cap.capId.toLowerCase().includes(searchLower)) return true;
            
            // Search in builder name
            if (cap.builderId) {
                const builder = builders?.find(b => b.builderId === cap.builderId);
                if (builder && builder.name.toLowerCase().includes(searchLower)) return true;
            }
            
            return false;
        }) : [];

        // Group caps by builder for search results
        const groupedCaps = statusSearchTerm ? filteredCaps.reduce((acc, cap) => {
            if (cap.builderId) {
                const builder = builders?.find(b => b.builderId === cap.builderId);
                if (builder) {
                    if (!acc[builder.builderId]) {
                        acc[builder.builderId] = {
                            builder,
                            caps: []
                        };
                    }
                    acc[builder.builderId].caps.push(cap);
                }
            }
            return acc;
        }, {}) : null;

        return (
            <View>
                {getUser().role === "ADMIN" && (
                    <div className="admin-controls">
                        <div className="new-cap-inputs">
                        <ContentEditable
                            html={newName}
                            className="ContentEditable-header"
                            disabled={isLoading}
                            onPaste={pastAsPlainText}
                            onKeyPress={disableNewLines}
                            onFocus={highlightAll}
                            onChange={handleNameChange}
                        />
                        <ContentEditable
                            html={newPort}
                            className="ContentEditable-text"
                            disabled={isLoading}
                            onPaste={pastAsPlainText}
                            onKeyPress={disableNewLines}
                            onFocus={highlightAll}
                            onChange={handlePortChange}
                        />
                        </div>
                        <div className="new-cap-buttons">
                        <Button
                            bsStyle="warning"
                            bsSize="small"
                            disabled={isLoading}
                            onClick={() => createNew("2CAM")}
                        >
                            <Glyphicon glyph="plus" /> Add 2-Camera System
                        </Button>
                        <Button
                            bsStyle="info"
                            bsSize="small"
                            onClick={() => createNew("4CAM")}
                        >
                            <Glyphicon glyph="plus" /> Add 4-Camera System
                        </Button>
                        <Button
                            bsStyle="success"
                            bsSize="small"
                            disabled={isLoading}
                            onClick={() => createNew()}
                        >
                            <Glyphicon glyph="plus" /> Add Legacy System
                        </Button>
                        <View style={{flex:1,flexDirection:"row",justifyContent:"flex-end"}} className="admin-add-builder-wrap">
                            <OverlayTrigger placement="left" overlay={(
                                <Tooltip id="addBuilder" style={{fontSize:"18px"}}>
                                    Add Builder
                                </Tooltip>
                            )}>
                                <Button
                                    className="btn-brand-dark btn-compact"
                                    onClick={() => setShowAddBuilder(true)}
                                >
                                    <Glyphicon glyph="plus" />
                                </Button>
                            </OverlayTrigger>
                        </View>
                        </div>
                    </div>
                )}
                <div className="admin-search-bar">
                    <FormGroup>
                        <div className="admin-search-row">
                            <FormControl
                                type="text"
                                placeholder="Search by builder name, cap ID, cap name, or neighborhood..."
                                value={statusSearchTerm}
                                onChange={(e) => setStatusSearchTerm(e.target.value)}
                                autoFocus
                            />
                            <Button
                                className="btn-brand-outline btn-compact"
                                onClick={() => setStatusSearchTerm("")}
                            >
                                <Glyphicon glyph="remove" />
                            </Button>
                            <Button
                                className="btn-brand-outline btn-compact"
                                onClick={refreshStatuses}
                                disabled={isLoading}
                            >
                                <Glyphicon glyph="refresh" />
                            </Button>
                        </div>
                    </FormGroup>
                </div>
                <div className="admin-cap-count">
                    Caps: {filteredCaps.filter(cap => cap.capId).length} of {organizedCaps ? organizedCaps.filter(cap => cap.capId && cap.status !== 'DECOMISSIONED').length : 0}
                </div>
                <Grid fluid className="admin-cap-status-list">
                    {statusSearchTerm ? (
                        // Show grouped results when searching
                        Object.values(groupedCaps).map(({ builder, caps: builderCaps }) => (
                            <React.Fragment key={builder.builderId}>
                                <Row>
                                    <Col md={12} style={{paddingTop:"10px",paddingRight:0,paddingLeft:0}}>
                                        <View style={{flex:1,flexDirection:"row",justifyContent:"space-between",flexWrap:"wrap"}}>
                                            <Button
                                                onClick={() => {
                                                    props.history.push(`/accesscontrol/${builder.builderId}`);
                                                }}
                                                style={{
                                                    width: "100%",
                                                    display:"block",
                                                    marginBottom: "10px"
                                                }}
                                            >
                                                <b>{builder.name}</b>
                                            </Button>
                                        </View>
                                    </Col>
                                </Row>
                                {builderCaps.map((cap, i) => (
                                    <Row key={i} className="admin-cap-row--search">
                                        <Col md={10}>
                                            <View className="cap-list-item" style={{flex:1,flexDirection:"row",justifyContent:"space-between",paddingTop:"2px"}}>
                                                <View style={{flex:1,flexDirection:"row",alignItems:"center"}}>
                                                    <Button
                                                        bsSize="small"
                                                        bsStyle="default"
                                                        style={{marginRight:"8px",marginBottom:"8px"}}
                                                        onClick={() => openHealthLog(cap)}
                                                    >
                                                        <Glyphicon glyph="info-sign" />
                                                    </Button>
                                                    <LinkContainer to={`/caps/${cap.capId}`} style={{fontSize:"16px",color:cap.status==="ACTIVE" ? "black" : "red",cursor:"pointer"}}>
                                                        <div className="cap-name" style={{flex:1,color:cap.status==="ACTIVE" ? "black" : "red"}}>
                                                            {cap.neighborhood ? cap.neighborhood+", "+cap.name : cap.name}
                                                        </div>
                                                    </LinkContainer>
                                                </View>
                                                <div className="cap-details">
                                                    {cap && cap.architecture && cap.architecture.match(/2CAM/) && <span>(2CAM)</span>}
                                                    {cap && cap.architecture && cap.architecture.match(/4CAM/) && <span>(4CAM)</span>}
                                                    {cap.port && <span>{cap.port.toString()}</span>}
                                                    {!isMobile && <CopyToClipboard text={cap.capId}>
                                                        <Button 
                                                            bsSize="small"
                                                            bsStyle="default"
                                                        ><Glyphicon glyph="duplicate" /></Button>
                                                    </CopyToClipboard>}  
                                                </div>
                                            </View>
                                        </Col>
                                        <Col md={2} style={{paddingTop:"5px"}}> 
                                            <Label bsStyle={stylePicker(cap.health, cap.status)}>
                                                {cap.status === 'DECOMISSIONED' ? 'DECOMISSIONED' : cap.health}
                                            </Label>
                                        </Col>
                                    </Row>
                                ))}
                            </React.Fragment>
                        ))
                    ) : (
                        // Show normal list when not searching
                        filteredCaps.map((cap,i) => (
                            <Row key={i}>
                                {cap.capId ? (
                                    <Col md={10}>
                                        <View className="cap-list-item" style={{flex:1,flexDirection:"row",justifyContent:"space-between",paddingTop:"2px"}}>
                                            <View style={{flex:1,flexDirection:"row",alignItems:"center"}}>
                                                <Button
                                                    bsSize="small"
                                                    bsStyle="default"
                                                    style={{marginRight:"8px"}}
                                                    onClick={() => openHealthLog(cap)}
                                                >
                                                    <Glyphicon glyph="info-sign" />
                                                </Button>
                                                <LinkContainer to={`/caps/${cap.capId}`} style={{fontSize:"16px",color:cap.status==="ACTIVE" ? "black" : "red",cursor:"pointer"}}>
                                                    <div className="cap-name" style={{flex:1,color:cap.status==="ACTIVE" ? "black" : "red"}}>
                                                        {cap.neighborhood ? cap.neighborhood+", "+cap.name : cap.name}
                                                    </div>
                                                </LinkContainer>
                                            </View>
                                            <div className="cap-details">
                                                {cap && cap.architecture && cap.architecture.match(/2CAM/) && <span>(2CAM)</span>}
                                                {cap && cap.architecture && cap.architecture.match(/4CAM/) && <span>(4CAM)</span>}
                                                {cap.port && <span>{cap.port.toString()}</span>}
                                                {!isMobile && <CopyToClipboard text={cap.capId}>
                                                    <Button 
                                                        bsSize="small"
                                                        bsStyle="default"
                                                    ><Glyphicon glyph="duplicate" /></Button>
                                                </CopyToClipboard>}  
                                            </div>
                                        </View>
                                    </Col>
                                ) : (
                                    <Col md={10} style={i>0?{paddingTop:"10px",paddingRight:0,paddingLeft:0}:{paddingRight:0,paddingLeft:0}}>
                                        <View>
                                            <View style={{flex:1,flexDirection:"row",justifyContent:"space-between"}}>
                                                <Button
                                                    onClick={() => {
                                                        props.history.push(`/accesscontrol/${cap.builderId}`);
                                                    }}
                                                    style={{width: "100%",display:"block"}}
                                                >
                                                    <b>{cap.name}</b>
                                                </Button>
                                                {!statusSearchTerm && caps && !caps.some(c => 
                                                    c.builderId === cap.builderId && 
                                                    (c.status === 'ACTIVE' || c.status === 'BUILD')
                                                ) && (
                                                    <Button
                                                        bsStyle="danger"
                                                        bsSize="small"
                                                        style={{marginLeft:"10px"}}
                                                        onClick={async () => {
                                                            if (window.confirm(`Are you sure you want to remove builder "${cap.name}"? This will set their status to DEAD.`)) {
                                                                // console.log('[Admin API] patchBuilder (DEAD)', cap.builderId);
                                                                await patchBuilder(cap.builderId, {status: 'DEAD'});
                                                                // Refresh both caps and builders lists
                                                                // console.log('[Admin API] getAccessableCaps(true), getAllBuilders() (refresh after patchBuilder)');
                                                                const [tempCaps, tempBuilders] = await Promise.all([
                                                                    getAccessableCaps(true),
                                                                    getAllBuilders()
                                                                ]);
                                                                tempCaps.sort((a,b) => (a.name < b.name) ? 1 : -1);
                                                                setCaps(tempCaps);
                                                                setBuilders(tempBuilders);
                                                            }
                                                        }}
                                                    >
                                                        <Glyphicon glyph="trash" />
                                                    </Button>
                                                )}
                                            </View>
                                        </View>
                                    </Col>
                                )}
                                {cap.capId ? (
                                    <Col md={2} style={{paddingTop:"5px"}}> 
                                        <Label bsStyle={stylePicker(cap.health, cap.status)}>
                                            {cap.status === 'DECOMISSIONED' ? 'DECOMISSIONED' : cap.health}
                                        </Label>
                                    </Col>
                                ) : (
                                    <Col md={2}>
                                    </Col>
                                )}
                            </Row>
                        ))
                    )}
                </Grid>
            </View>
        )
    }

    // function renderSharingManager() {

    //     return (
    //         <div className="wrapper"> {/*style={{ width: "70vw", height: "70vh", overflow: "auto" }}>*/}
    //             {/* <AutoResizer>
    //                 {({ width, height }) => (
    //                 <BaseTable fixed columns={capRow} data={userGrid ? userGrid : []} width={width} height={height} >

    //                 </BaseTable>
    //                 )}  
    //             </AutoResizer> */}
    //             <table className="table table-bordered">
    //                 <thead>
    //                     <tr>
    //                         {/* <th style={{position:"sticky",top:"0px", background:"white",zIndex:9999,left:"0px"}}></th> */}
    //                         <th></th>
    //                         {caps && caps.map((cap,i) => (
    //                             // <th key={i} style={{fontSize:"10px",position:"sticky",top:"0",background:"white",zIndex:9999}}>
    //                             <th key={i} style={{fontSize:"10px"}}>
    //                                 {cap.neighborhood ? cap.name+", "+cap.neighborhood : cap.name}
    //                             </th>
    //                         ))}
    //                     </tr>
    //                 </thead>
    //                 <tbody>
    //                     {userGrid && Object.keys(userGrid).map((userId,i) => (
    //                         <tr key={i}>
    //                             {/* <td style={{fontSize:"10px",left:"0",background:"white",zIndex:9999}}> */}
    //                             <td style={{fontSize:"10px"}}>
    //                                 {userGrid[userId].email}
    //                             </td>
    //                         {caps && caps.map((cap,j) => (
    //                             <td key={j}>
    //                                 <form>
    //                                     <FormGroup controlId={userId+cap.capId}>
    //                                         <Button 
    //                                                 bsStyle={getBsStyle(lookupAccess)} 
    //                                                 style={{width:"100%"}}
    //                                                 disabled={userGrid[userId].role==="ADMIN"}
    //                                                 onClick={() => handleUpdateAccess(userId,cap.capId)}
    //                                             >
    //                                             {userGrid[userId].role==="ADMIN" ? "ADMIN" : userGrid[userId][cap.capId] ? userGrid[userId][cap.capId].accessType : "DENIED"}
    //                                         </Button> 
    //                                         {userGrid[userId][cap.capId] && (
    //                                             <Checkbox checked={userGrid[userId][cap.capId].powerNotifications} onChange={() => handleUpdatePowerNotifications(userId,cap.capId)}>
    //                                                 <Glyphicon glyph="envelope" />
    //                                             </Checkbox>
    //                                         )}
    //                                     </FormGroup>
    //                                 </form>
    //                             </td>
    //                         ))}
    //                         </tr>
    //                     ))}
    //                 </tbody>
    //             </table>
    //         </div>
    //     )
    // }

    function renderUsers() {
        var todayLogins = {};
        var yesterdayLogins = {}
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate()-1);
        const twoDays = new Date();
        twoDays.setDate(twoDays.getDate()-2);
        if(data) {
            for(var i=0; i<data.length; i++) {
                for(var j=0; j<data[i].data.length; j++) {
                    const d = new Date(data[i].data[j][0]);
                    if(d > yesterday) {
                        todayLogins[data[i].label] = data[i].data[j][1];
                    }
                    if(d > twoDays && d < yesterday) {
                        yesterdayLogins[data[i].label] = data[i].data[j][1];
                    }
                }
            }
        }
        return (
            <div className="admin-login-panel">
                {todayLogins && (
                    <div className="admin-login-section">
                        <h3>Logged in today</h3>
                        <div className="admin-login-user-list">
                        {Object.keys(todayLogins).sort().map((email,i) => (
                            <div key={i} className="admin-stat-row">
                                <span>{email}</span>
                                <span>{todayLogins[email]}</span>
                            </div>
                        ))}
                        </div>
                    </div>
                )}
                {yesterdayLogins && (
                    <div className="admin-login-section">
                        <h3>Logged in yesterday</h3>
                        <div className="admin-login-user-list">
                        {Object.keys(yesterdayLogins).sort().map((email,i) => (
                            <div key={i} className="admin-stat-row">
                                <span>{email}</span>
                                <span>{yesterdayLogins[email]}</span>
                            </div>
                        ))}
                        </div>
                    </div>
                )}
            </div>
        )
    }

    function renderAllUsers() {
        return <AllUsers history={props.history} />;
    }

    function renderTransfers() {
        return <Transfers history={props.history} builders={builders} />;
    }

    function renderCapMap() {
        return <AdminCapMap caps={caps} />;
    }

    function renderBadAccess() {
        props.history.push("/dashboard")
    }

    return (
        <div className="admin-page">
            <header className="admin-header">
                <nav className="brand-breadcrumb">
                    <span className="brand-breadcrumb-current">Admin</span>
                </nav>
                <h1 className="admin-title">Admin</h1>
            </header>
            {getUser().role === "ADMIN" ? renderStatsMenus() : renderBadAccess()}
            {getUser().role === "ADMIN" && (
                <AddBuilderModal 
                    show={showAddBuilder}
                    setShowAddBuilder={setShowAddBuilder}
                />
            )}
            {getUser().role === "ADMIN" && selectedCapForHealth && (
                <CapLogModal 
                    show={showHealthLog}
                    setShow={setShowHealthLog}
                    capId={selectedCapForHealth.capId}
                    capName={selectedCapForHealth.neighborhood ? selectedCapForHealth.neighborhood+", "+selectedCapForHealth.name : selectedCapForHealth.name}
                />
            )}
        </div>
    )
}